// extracted by css-extract-rspack-plugin
export default {"notificationArea":"notificationArea-CX47iW"};